export default "__VITE_ASSET__7a111c27__"